import React, { Fragment } from 'react'
import { Card, CardText, CardBody, CardTitle } from 'reactstrap'

const MissionVision = ({ content }) => (
  <Fragment>
    <div className="pv5" style={{background:'#fafafa'}}>
      <div className="container">
        <div className="row">
          {content.body.map((item, index) => (
            <div className="col-md-6" key={index}>
              <Card className="br3 mb-3">
                <CardBody className="pa4">
                  <img
                    src={item.icon}
                    className="w2 db mb-3 mt-2 center"
                    alt={item.icon} style={{width:'10%'}}
                  />
                  <CardTitle
                    className="tc ttu mb-3"
                    style={{ color: '#dc0d18' }}
                  >
                    {item.title}
                  </CardTitle>
                  <CardText className="tc mb-3">{item.content}</CardText>
                </CardBody>
              </Card>
            </div>
          ))}
        </div>
      </div>
    </div>
  </Fragment>
);

export default MissionVision



// WEBPACK FOOTER //
// ./src/views/about/mission-vision.js